<template>
  <v-reports
    v-if="access.report_shift"
    v-model="page"
    v-bind:headers="headers"
    v-bind:update="update"
    v-bind:data="data"
    v-bind:row="row_clicked"
    v-bind:numPages="numPages"
    :data_loading="data_loading"
    @change-pagination="changePagination"
  >
    <template #drawer>
      <v-navigation-drawer
        v-model="drawer"
        right
        absolute
        :width="drawer ? 380 : 0"
      >
        <v-progress-linear
          v-if="loading_receipt"
          indeterminate
          color="primary"
        ></v-progress-linear>
        <v-layout row px-4 py-2>
          <v-spacer />
          <v-hover #default="{ hover }">
            <v-btn icon @click="drawer = false">
              <v-icon :class="hover ? 'black--text rotate90' : 'grey--text'"
                >mdi-close</v-icon
              >
            </v-btn>
          </v-hover>
        </v-layout>

        <v-layout row px-2>
          <v-flex px-2 mx-2 md12 class="text-center">
            <p class="font-weight-bold body-2">{{ $t(`shift_report`) }}</p>
          </v-flex>
        </v-layout>
        <hr class="mx-2" style="border: 0.5px dashed grey" />
        <v-layout row px-2>
          <v-flex md12 px-2 mx-2>
            <p class="mt-2 mb-2 body-2">
              {{ $t(`store`) }}: {{ current_receipt.service_name }}
            </p>
            <p class="mt-0 mb-0 body-2">
              {{ $t(`pos`) }}: {{ current_receipt.pos }}
            </p>
          </v-flex>
        </v-layout>
        <v-layout row px-1 mx-2>
          <v-flex md6>
            <p class="mt-2 mb-0 body-2">
              {{ $t(`shift_opened`) }}: {{ current_receipt.by_whom_name }}
            </p>
          </v-flex>
          <v-flex md6 class="text-right body-2">
            <p class="mt-2 mb-0">
              {{ date_ddmmyy_hhmm(current_receipt.opening_time) }}
            </p>
          </v-flex>
        </v-layout>
        <v-layout row px-1 mx-2>
          <v-flex md6 v-if="!current_receipt.by_whom_name_close">
            <p class="mt-2 mb-0 body-2">
              {{ $t(`shift_closed`) }}: {{ current_receipt.by_whom_name }}
            </p>
          </v-flex>
          <v-flex md6 v-else>
            <p class="mt-2 mb-0 body-2">
              {{ $t(`shift_closed`) }}: {{ current_receipt.by_whom_name_close }}
            </p>
          </v-flex>
          <v-flex md6 class="text-right body-2">
            <p class="mt-2 mb-0">
              {{ date_ddmmyy_hhmm(current_receipt.closing_time) }}
            </p>
          </v-flex>
        </v-layout>

        <hr class="mx-2 mt-2" style="border: 0.5px dashed grey" />

        <v-layout row px-2>
          <v-flex md12 pa-2 mx-2 class="mb-0">
            <p class="font-weight-bold mb-0 primary--text body-2">
              {{ $t(`cash_drawer`) }}
            </p>
          </v-flex>
        </v-layout>

        <v-layout row px-1 mx-2>
          <v-flex md8>
            <p class="mt-2 mb-0 body-2">{{ $t(`starting_cash`) }}:</p>
          </v-flex>
          <v-flex md4 class="text-right body-2">
            <p class="mt-2 mb-0">
              {{ current_receipt.cash_drawer.starting_cash.toLocaleString() }}
            </p>
          </v-flex>
        </v-layout>

        <v-layout row px-1 mx-2>
          <v-flex md8>
            <p class="mt-2 mb-0 body-2">{{ $t(`cash_payments`) }}:</p>
          </v-flex>
          <v-flex md4 class="text-right">
            <p class="mt-2 mb-0 body-2">
              {{ current_receipt.cash_drawer.cash_payment.toLocaleString() }}
            </p>
          </v-flex>
        </v-layout>

        <v-layout row px-1 mx-2>
          <v-flex md8>
            <p class="mb-0 body-2">{{ $t(`cash_refunds`) }}:</p>
          </v-flex>
          <v-flex md4 class="text-right">
            <p class="mt-2 mb-0 body-2">
              {{ current_receipt.cash_drawer.cash_refund.toLocaleString() }}
            </p>
          </v-flex>
        </v-layout>

        <v-layout row px-1 mx-2>
          <v-flex md8>
            <p class="mt-2 mb-0 body-2">{{ $t(`paid_in`) }}:</p>
          </v-flex>
          <v-flex md4 class="text-right">
            <p class="mt-2 mb-0 body-2">
              {{ current_receipt.cash_drawer.paid_in.toLocaleString() }}
            </p>
          </v-flex>
        </v-layout>

        <v-layout row px-1 mx-2>
          <v-flex md8>
            <p class="mt-2 mb-0 body-2">{{ $t(`paid_in`) }}:</p>
          </v-flex>
          <v-flex md4 class="text-right">
            <p class="mt-2 mb-0 body-2">
              {{ current_receipt.cash_drawer.paid_out.toLocaleString() }}
            </p>
          </v-flex>
        </v-layout>

        <v-layout row px-1 mx-2>
          <v-flex md8>
            <p class="mt-2 mb-0 body-2">{{ $t(`exp_cash_amount`) }}:</p>
          </v-flex>
          <v-flex md4 class="text-right">
            <p class="mt-2 mb-0 body-2">
              {{ current_receipt.cash_drawer.exp_cash_amount.toLocaleString() }}
            </p>
          </v-flex>
        </v-layout>

        <v-layout row px-1 mx-2>
          <v-flex md8>
            <p class="mt-2 mb-0 body-2">{{ $t(`act_cash_amount`) }}:</p>
          </v-flex>
          <v-flex md4 class="text-right">
            <p class="mt-2 mb-0 body-2">
              {{ current_receipt.cash_drawer.act_cash_amount.toLocaleString() }}
            </p>
          </v-flex>
        </v-layout>

        <v-layout row px-1 mx-2>
          <v-flex md8>
            <p class="mt-2 mb-2 body-2">{{ $t(`difference`) }}:</p>
          </v-flex>
          <v-flex md4 class="text-right">
            <p class="mt-2 mb-2 body-2">
              {{
                (
                  current_receipt.cash_drawer.act_cash_amount -
                  current_receipt.cash_drawer.exp_cash_amount
                ).toLocaleString()
              }}
            </p>
          </v-flex>
        </v-layout>

        <hr class="mx-2 font-regular" style="border: 0.5px dashed grey" />

        <v-layout row px-2>
          <v-flex md12 pa-2 mx-2 class="mb-0">
            <p class="font-weight-bold mb-0 primary--text body-2">
              {{ $t(`sales_summary`) }}
            </p>
          </v-flex>
        </v-layout>

        <v-layout row px-1 mx-2>
          <v-flex md8>
            <p class="mt-2 mb-0 body-2">{{ $t(`gross_sales`) }}</p>
          </v-flex>
          <v-flex md4 class="text-right">
            <p class="mt-2 mb-0 body-2">
              {{ current_receipt.sales_summary.gross_sales.toLocaleString() }}
            </p>
          </v-flex>
        </v-layout>

        <v-layout row px-1 mx-2>
          <v-flex md8>
            <p class="mt-2 mb-0 body-2">{{ $t(`card`) }}</p>
          </v-flex>
          <v-flex md4 class="text-right">
            <p class="mt-2 mb-0 body-2">
              {{ current_receipt.sales_summary.card.toLocaleString() }}
            </p>
          </v-flex>
        </v-layout>

        <v-layout row px-1 mx-2>
          <v-flex md8>
            <p class="mt-2 mb-0 body-2">{{ $t(`cash`) }}</p>
          </v-flex>
          <v-flex md4 class="text-right">
            <p class="mt-2 mb-0 body-2">
              {{ current_receipt.sales_summary.cash.toLocaleString() }}
            </p>
          </v-flex>
        </v-layout>

        <v-layout row px-1 mx-2>
          <v-flex md8>
            <p class="mt-2 mb-0 body-2">{{ $t(`cashback_out`) }}</p>
          </v-flex>
          <v-flex md4 class="text-right body-2">
            <p class="mt-2 mb-0">
              {{ current_receipt.sales_summary.cashback_out.toLocaleString() }}
            </p>
          </v-flex>
        </v-layout>

        <v-layout row px-1 mx-2>
          <v-flex md8>
            <p class="mt-2 mb-0 body-2">{{ $t(`refunds`) }}</p>
          </v-flex>
          <v-flex md4 class="text-right body-2">
            <p class="mt-2 mb-0">
              {{ current_receipt.sales_summary.refunds.toLocaleString() }}
            </p>
          </v-flex>
        </v-layout>

        <v-layout row px-1 mx-2>
          <v-flex md8>
            <p class="mt-2 mb-0 body-2">{{ $t(`discounts`) }}</p>
          </v-flex>
          <v-flex md4 class="text-right body-2">
            <p class="mt-2 mb-0">
              {{ current_receipt.sales_summary.discounts.toLocaleString() }}
            </p>
          </v-flex>
        </v-layout>

        <v-layout row px-1 mx-2>
          <v-flex md8>
            <p class="mt-2 mb-2 body-2">{{ $t(`net_sales`) }}</p>
          </v-flex>
          <v-flex md4 class="text-right">
            <p class="mt-2 mb-2 body-2">
              {{ current_receipt.sales_summary.net_sales.toLocaleString() }}
            </p>
          </v-flex>
        </v-layout>

        <v-layout row px-1 mx-2>
          <v-flex md8>
            <p class="mt-2 mb-0 body-2">{{ $t(`taxes`) }}</p>
          </v-flex>
          <v-flex md4 class="text-right">
            <p class="mt-2 mb-0 body-2">
              {{ current_receipt.sales_summary.taxes.toLocaleString() }}
            </p>
          </v-flex>
        </v-layout>

        <hr
          class="mx-2 mt-2"
          style="border: 0.5px dashed grey"
          v-if="current_receipt.Pays.length > 0"
        />

        <v-layout row px-2 v-if="current_receipt.Pays.length > 0">
          <v-flex md12 pa-2 mx-2 class="mb-0">
            <p class="font-weight-bold mb-0 primary--text body-2">
              {{ $t(`paid_in`) }} / {{ $t(`paid_out`) }}
            </p>
          </v-flex>
        </v-layout>

        <v-layout
          row
          px-1
          mx-2
          v-for="(itm, ind) in current_receipt.Pays"
          :key="ind"
        >
          <v-flex md3>
            <p class="mt-2 mb-0 body-2">
              {{ new Date().toString(itm.time).slice(16, 21) }}
            </p>
          </v-flex>
          <v-flex md6>
            <p class="mt-2 mb-0 body-2">{{ itm.who }} - {{ itm.comment }}</p>
          </v-flex>
          <v-flex md3 class="text-right">
            <p class="mt-2 mb-0 body-2">
              {{ itm.value ? itm.value.toLocaleString() : itm.value }}
            </p>
          </v-flex>
        </v-layout>
        <hr class="mx-2 mt-2 mb-10" style="border: 0.5px dashed grey" />
      </v-navigation-drawer>
    </template>
  </v-reports>
  <error404 v-else></error404>
</template>
<script>
export default {
  name: "Shifts",
  data: () => ({
    drawer: false,
    current_receipt: {
      cash_drawer: {
        starting_cash: 0,
        cash_payment: 0,
        cash_refund: 0,
        difference: 0,
        act_cash_amount: 0,
        exp_cash_amount: 0,
        paid_out: 0,
        paid_in: 0,
      },
      sales_summary: {
        card: 0,
        cash: 0,
        gross_sales: 0,
        refunds: 0,
        discounts: 0,
        net_sales: 0,
        taxes: 0,
        cashback_out: 0,
      },
      Pays: [],
    },
    loading_receipt: false,
    headers: [
      { text: "POS", value: "pos", available: true, disabled: true },
      { text: "Opening time", value: "opening_time", available: true },
      { text: "Closing time", value: "closing_time", available: true },
      {
        text: "gross_sales",
        value: "sales_summary.gross_sales",
        available: true,
      },
      {
        text: "Expected cash amount",
        value: "exp_cash_amount",
        available: true,
      },
      { text: "Actual cash amount", value: "act_cash_amount", available: true },
      { text: "Difference", value: "difference", available: true },
    ],
    data: [],
    all_receipts: 0,
    saled_receipts: 0,
    refund_receipts: 0,
    params: {},
    page: 1,
    numPages: 1,
    data_loading: false,
    mytab: 0,
    err: null,
    access: null,
  }),

  methods: {
    async row_clicked(item) {
      this.loading_receipt = true;
      this.drawer = true;
      var receipt = this.$communicator.then(
        this,
        await this.$communicator("shift_by_id", {
          arguments: [item._id],
        })
      );
      try {
        this.current_receipt = receipt;
      } catch (error) {
        this.err = error;
      }
      this.loading_receipt = false;
    },
    myfunc() {
      this.update();
    },
    changePagination(page) {
      this.page = page;
      this.update(this.params);
    },
    async update(params) {
      this.data_loading = true;
      this.params = params;
      var start_date = new Date(params.start_date).getTime();
      var end_date = new Date(params.end_date).getTime();
      var shifts = this.$communicator.then(
        this,
        await this.$communicator("by_shift", {
          arguments: [start_date, end_date, 10, this.page],
          params: {
            custom: params.custom,
            start: params.start.time,
            end: params.end.time,
            services: params.service != "" ? [params.service] : [],
            employees: params.employee._id != "" ? [params.employee._id] : [],
          },
        })
      );
      for (let i = 0; i < shifts.data.length; i++) {
        shifts.data[i].act_cash_amount = Math.round(
          shifts.data[i].act_cash_amount
        ).toLocaleString();
        shifts.data[i].difference = Math.round(
          shifts.data[i].difference
        ).toLocaleString();
        shifts.data[i].exp_cash_amount = Math.round(
          shifts.data[i].exp_cash_amount
        ).toLocaleString();
        shifts.data[i].sales_summary.gross_sales =
          shifts.data[i].sales_summary.gross_sales.toLocaleString();
        var time = shifts.data[i].opening_time;
        shifts.data[i].opening_time = this.date_ddmmyy(time);
        // time.getDate() + "/" + (time.getDay() + 1) + "/" + time.getFullYear();
        time = shifts.data[i].closing_time;
        shifts.data[i].closing_time = this.date_ddmmyy(time);
        // time.getDate() + "/" + (time.getDay() + 1) + "/" + time.getFullYear();
      }
      this.data = shifts.data;
      this.data_loading = false;
      this.numPages = shifts.page;
    },
  },
  mounted() {
    this.headers = [
      { text: this.$t(`pos`), value: "pos", available: true, disabled: true },
      { text: this.$t(`opening_time`), value: "opening_time", available: true },
      { text: this.$t(`closing_time`), value: "closing_time", available: true },
      {
        text: this.$t(`gross_sales`),
        value: "sales_summary.gross_sales",
        available: true,
      },
      {
        text: this.$t(`exp_cash_amount`),
        value: "exp_cash_amount",
        available: true,
      },
      {
        text: this.$t(`act_cash_amount`),
        value: "act_cash_amount",
        available: true,
      },
      { text: this.$t(`difference`), value: "difference", available: true },
    ];
    for (const index in this.headers) {
      this.headers[index]["sortable"] = false;
    }
  },
  beforeMount() {
    this.access = this.$store.state.access;
  },
};
</script>

<style scoped>
.rotate90 {
  transform: rotate(90deg);
}
</style>
